var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(name){return _c('span',{key:("aka-" + (name.name)),staticClass:"verifications-components-pep-aka"},[_vm._v("\n    "+_vm._s(name.name)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }